import { createFileRoute, useNavigate } from '@tanstack/react-router';
import {
  type CollectorsSearchPatch,
  parseCollectorsSearch,
  withCollectorsSearch,
} from '~portal/components/admin/automations/collectors/collector-search';
import { CollectorsList } from '~portal/components/admin/automations/collectors/CollectorsList';
import { logger } from '~portal/lib';

/**
 * @desc Automations → Collectors (H2-7, task 8.3). Filters and the open drawer (`?collector=`)
 * live in the URL, so a collector can be linked to — the Runs page does.
 */
export const Route = createFileRoute('/_protected/admin/ario/collectors')({
  validateSearch: parseCollectorsSearch,
  component: AutomationCollectorsPage,
});

function AutomationCollectorsPage() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  const update = (patch: CollectorsSearchPatch) => {
    navigate({
      search: (prev) => withCollectorsSearch(prev, patch),
      // Filters and the drawer change the page in place; keep the list's scroll position.
      resetScroll: false,
    }).catch((err: unknown) => {
      logger.error('[AutomationCollectors] Navigation failed', {
        error: err instanceof Error ? err.message : String(err),
      });
    });
  };

  return <CollectorsList search={search} onSearch={update} />;
}
